export * from './IslamicI18n';
